import { useMutation, useQueryClient } from '@tanstack/react-query';
import { client } from '../api';

interface DismissResponse {
  status: string;
}

/**
 * Hook to dismiss the universal search NUX with automatic cache invalidation.
 * When the NUX is dismissed, the checkLogin query (which fetches from /info)
 * will be invalidated to refetch and update the show_universal_search_nux flag.
 */
export const useDismissUniversalSearchNux = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (): Promise<DismissResponse> => {
      const response = await client.post<DismissResponse>('/universal-search-nux/dismiss');
      return response.data;
    },
    onSuccess: () => {
      // Invalidate the checkLogin query to refetch user data and update feature flags
      queryClient.invalidateQueries({ queryKey: ['checkLogin'] });
    },
  });
};
